export default __webpack_public_path__ + "static/media/sample-canvas.0537c13e.png";